// import _ from "lodash";
import cnt from "../../services/definedConstant";

const RIGHT_INITIAL_STATE = {
  searchBtn: "default",
  addBtn: "default",
  saveBtn: "default",
  detailBtn: "default",
  editBtn: "default",
  deleteBtn: "default",
  approveBtn: "default",
  rejectBtn: "default",
  disburseBtn: "default",
  runBtn: "default",
};

export const RightSideBtn = (state = RIGHT_INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case cnt.RIGHT_SEARCH_BTN:
      return { ...state, searchBtn: "primary" };
    case cnt.RIGHT_ADD_BTN:
      return { ...state, addBtn: "primary" };
    case cnt.RIGHT_SAVE_BTN:
      return { ...state, saveBtn: "primary" };
    case cnt.RIGHT_DETAIL_BTN:
      return { ...state, detailBtn: "primary" };
    case cnt.RIGHT_EDIT_BTN:
      return { ...state, editBtn: "primary" };
    case cnt.RIGHT_DELETE_BTN:
      return { ...state, deleteBtn: "primary" };
    case cnt.RIGHT_APPROVE_BTN:
      return { ...state, approveBtn: "primary" };
    case cnt.RIGHT_REJECT_BTN:
      return { ...state, rejectBtn: "primary" };
    case cnt.RIGHT_DISBURSE_BTN:
      return { ...state, disburseBtn: "primary" };
    case cnt.RIGHT_RUN_BTN:
      return { ...state, runBtn: "primary" };
    case cnt.CLEAR_RIGHT_BTN:
      return { ...RIGHT_INITIAL_STATE };
    default:
      return state;
  }
};

const BLOCK_RED_INITIAL_STATE = {
  currentTemplate: {
    name: null,
    data: {},
  },
};
export const BlockReducer = (state = BLOCK_RED_INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case cnt.CURRENT_TEMPLATE:
      return { currentTemplate: payload };
    default:
      return state;
  }
};
